module.exports = __webpack_public_path__ + "static/media/add past paper.22b10163.svg";